import { render } from "./PartnerInfo.vue?vue&type=template&id=14225f03&scoped=true"
import script from "./PartnerInfo.vue?vue&type=script&lang=js"
export * from "./PartnerInfo.vue?vue&type=script&lang=js"

import "./PartnerInfo.vue?vue&type=style&index=0&id=14225f03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14225f03"]])

export default __exports__